import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  onBecomeObserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
import { CommonPathWay } from "../../Components/CommonPathWay";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage";
class DashboardStore {
  userRole = "Super Admin";
  inactiveModalShow = false;
  inviteID = "";
  multiRingData = {
    valid: true,
    data: [],
    total: 20,
    header: "Customer SignUp Stats",
  };
  totalUsageCredits = {
    type: "cards",
    label: "Usage Summary",
    valid: true,
    data: [],
  };
  paidUsersTableData = [];
  pageSize = 10;
  currentPage = 0;
  totalPages = 1;
  userdashboarddata = null;
  recentSaveSearchs =null;
  searchInput = "";
  paidUserSearch = "";
  recentLoginInfo = {};
  calendarValue = {
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
  };
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
 
    reaction(
      () => this.calendarValue.startDate,
      (newValue, oldValue) => {
        this.handleSignupStats();
        this.handleLoginInfo();
        this.handleTotalUsedCredits();
        this.getuserdetailsapi();
      this.getrecentSaveSearchs();
      }
    );
    reaction(
      () => this.searchInput,
      () => {
        this.handleLoginInfo();
      }
    );
    reaction(
      () => this.searchInput,
      () => {
        this.handleLoginInfo();
      }
    );
  }

    userActiveHandle = async (location) => {
    const urlParams = new URLSearchParams(location.search);
    const invite = urlParams.get("invite-code");
    let inviteActive = false;
    if (invite) {
      try {
        const response = await CommonPathWay(
          `/team-management/invite/code/verify`,
          "POST",
          {},
          {
            invite_code: invite ,
          }
        );
        if (response) {
          inviteActive = response?.data?.status;
        }
      } catch (e) {
        console.error(e);
      }
      if (inviteActive) {
        runInAction(() => {
          this.inviteID = invite ;
          this.inactiveModalShow = true;
        });
      }
    }
  }

  async handleActiveUser(acceptValue) {
     try {
      const response = await CommonPathWay(
        `${acceptValue === true ? "/team-management/invite/conform" : "/team-management/invite/decline"}`,
        "POST",
        {},
        {
          invite_code: this.inviteID,
        }
      );
      if (response) {
        runInAction(() => {
          this.inactiveModalShow = false;
          showAlertToast({
            type: "success",
            title: acceptValue === true ? "Accept Invite" : "Decline Invite",
            message:
              (acceptValue === true ? "accepted" : "declined") + " the invite.",
          });
        });
        if (acceptValue === true) {
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        }
       
      }
    } catch (e) {
      console.error(e);
    }
  }

   async getuserdetailsapi() {
    try {
      const response = await commonAxios(
        "/userDashBoardInfo",
        "POST",
        {},
        {}
      );
      if (response) {
        runInAction(() => {
          this.userdashboarddata = response.data;
        });
      }
    } catch (e) {
    }
  }
   async getrecentSaveSearchs() {
    try {
      const response = await commonAxios(
        "/recentSaveSearchs",
        "POST",
        {},
        {}
      );
      if (response) {
        runInAction(() => {
          this.recentSaveSearchs = response.data;
        });
      }
    } catch (e) {
    }
  }
  handleSignupStats = async () => {
    try {
      const response = await commonAxios(
        "/signupInfo",
        "POST",
        {},
        {
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.multiRingData = response.data;
        });
        this.rootStore.getuserdetails();
      }
    } catch (e) {
    }
  };
  handleLoginInfo = async () => {
    try {
      const response = await commonAxios(
        "/lastLoginInfo",
        "POST",
        {},
        {
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
          search: this.searchInput,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.recentLoginInfo = response.data;
        });
      }
    } catch (e) {
    }
  };
  handleTotalUsedCredits = async () => {
    try {
      const response =
       await commonAxios(
        "/totalUsedCredits",
        "POST",
        {},
        {
          startDate: this.calendarValue.startDate,
          endDate: this.calendarValue.endDate,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.totalUsageCredits = response.data;
        });
      }
    } catch (e) {
    }
  };
  handlePaidUsersTable = async () => {
    try {
      const response = await commonAxios(
        "/totalSubscriptionHistory",
        "POST",
        {},
        {}
      );
      if (response?.data) {
        runInAction(() => {
          this.paidUsersTableData = response.data;
        });
      }
    } catch (e) {
    }
  };
  formatFieldName = (key) => {
    return key
      ?.replace(/[_\s]+/g, " ") // Replace underscores or spaces with a single space
      ?.replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
      ?.replace(/\b\w/g, (match) => match.toUpperCase()); // Capitalize first letter of each word
  };
  setCalendarValue = (value) => {
    this.calendarValue = value;
  };
  setSearchInput = (value) => {
    this.searchInput = value;
  };
  setPaidUserSearch = (value) => {
    this.paidUserSearch = value;
  };
  setPageSize = (size) => {
    this.pageSize = size;
  };
  setCurrentPage = (page) => {
    if (page < 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = page;
    }
  };
}
export default DashboardStore;
